import { NgModule } from '@angular/core';
import { TransformObjectPipe } from './transform-object.pipe';
import { TransformObjectService } from './transform-object.service';
import { TransformObjectsPipe } from './transform-objects.pipe';

@NgModule({
  declarations: [TransformObjectPipe, TransformObjectsPipe],
  exports: [TransformObjectPipe, TransformObjectsPipe],
  providers: [TransformObjectService]
})
export class TransformObjectModule {}
